var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2812 7.34375H0.71875C0.445312 7.34375 0.25 7.14844 0.25 6.875V5.625C0.25 5.39062 0.445312 5.15625 0.71875 5.15625H17.2812C17.5156 5.15625 17.75 5.39062 17.75 5.625V6.875C17.75 7.14844 17.5156 7.34375 17.2812 7.34375ZM17.2812 13.5938H0.71875C0.445312 13.5938 0.25 13.3984 0.25 13.125V11.875C0.25 11.6406 0.445312 11.4062 0.71875 11.4062H17.2812C17.5156 11.4062 17.75 11.6406 17.75 11.875V13.125C17.75 13.3984 17.5156 13.5938 17.2812 13.5938ZM17.2812 19.8438H0.71875C0.445312 19.8438 0.25 19.6484 0.25 19.375V18.125C0.25 17.8906 0.445312 17.6562 0.71875 17.6562H17.2812C17.5156 17.6562 17.75 17.8906 17.75 18.125V19.375C17.75 19.6484 17.5156 19.8438 17.2812 19.8438Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.dba15eac9ee340e279ccbffdcdab7518.svg";
export { ForwardRef as ReactComponent };